import PaginationData from "@/models/general/PaginationData";
import Reservation from "@/models/reservations/reservations/Reservation";
import ReservationsFilter from "@/models/reservations/reservations/ReservationsFilter";

export default class Reservations {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.pagination = new PaginationData();
    this.reservationsData = [];
    this.reservation = new Reservation();
    this.filterData = new ReservationsFilter();
  }
  fillData(data) {
    this.status = data.status;
    this.msg = data.msg;
    this.pagination.fillData(data.pagination);
    this.reservationsData = data.reservationData;
  }
}
